import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  138: { name: 'Decking' },
  139: { name: 'Fencing' },
  140: { name: 'Garden Clearance' },
  141: { name: 'Garden Maintenance' },
  142: { name: 'Hedge Cutting' },
  143: { name: 'Landscaping' },
  144: { name: 'Pressure Washing' },
  145: { name: 'Tree Surgery' },
  146: { name: 'Turfing' },
};

const AdminLandscapingPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="External Works & Landscaping Pricing Rules"
    description="Manage pricing for 9 landscaping services"
  />
);

export default AdminLandscapingPricingRules;
